import { useEffect, useState } from 'react'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil'
import { ColumnsType } from 'antd/lib/table'
import { DeleteIcon } from './styles'
import { IMAGE_URL } from '@/constant/IMAGE'
import { useHealthClaimAutoAssignment } from '@/services/healthClaim/useHealthClaimAutoAssignment'
import { TablePaginationConfig } from 'antd'
import { BehaviorSubject, debounceTime, distinctUntilChanged } from 'rxjs'
import { validatePerm } from '@/libs/validatePermission'
import userAtom from '@/recoil/user'
import { BACKOFFICE_USER_PERMISSION } from '@/constant/BACKOFFICE_PERMISSION'
import deleteAutoAssignModalAtom from '@/recoil/deleteAutoAssignModal'
import addAssignMemberModalAtom from '@/recoil/addAssignMemberModal'
import { UserSelectStyle } from '@/components/common/Table/styles'

const inputChange = new BehaviorSubject('')
const inputChange$ = inputChange.asObservable()

const AutoAssignTableHook = () => {
  const setDeleteAutoAssignModal = useSetRecoilState(deleteAutoAssignModalAtom)
  const setAddAssignMemberModal = useSetRecoilState(addAssignMemberModalAtom)
  const user = useRecoilValue(userAtom)
  const [search, setSearch] = useState<string>('')
  const [page, setPage] = useState(1)
  const [limit, setLimit] = useState(10)
  const onSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value
    inputChange.next(value)
  }

  const queryListAutoAssignee = useHealthClaimAutoAssignment({
    search,
    page,
    limit,
    enabled: true,
  })

  const handleAddUser = () => {
    setAddAssignMemberModal({
      isVisible: true,
      onOkFunction: () => {
        queryListAutoAssignee.refetch()
      },
      onCancelFunction: () => {
        queryListAutoAssignee.refetch()
      },
      okButtonProps: { type: 'primary', danger: false },
    })
  }

  const columns: ColumnsType<any> = [
    {
      title: 'ลำดับ',
      align: 'center',
      className: UserSelectStyle,
      render: (_value, _record, index) => {
        return index + 1
      },
      width: 90,
    },
    {
      title: 'ชื่อ-นามสกุล',
      width: 200,
      className: UserSelectStyle,
      render: (_value, record) => {
        return `${record.firstname} ${record.lastname}`
      },
    },
    {
      title: 'รหัสพนักงาน',
      dataIndex: 'employeeCode',
      width: 150,
      className: UserSelectStyle,
    },
    {
      title: 'จำนวนงานที่ Auto Assign',
      dataIndex: 'countAutoAssign',
      width: 200,
      className: UserSelectStyle,
    },
    {
      title: 'จำนวนงานที่รับทำ',
      dataIndex: 'countOwner',
      width: 200,
      className: UserSelectStyle,
    },
    {
      title: 'ชื่อทีม',
      dataIndex: 'teamName',
      className: UserSelectStyle,
    },
    validatePerm([BACKOFFICE_USER_PERMISSION.APP010103], user.permissions)
      ? {
          title: '',
          width: 50,
          render: (_value, record) => {
            return (
              <DeleteIcon
                src={IMAGE_URL.trashIcon}
                onClick={() =>
                  handelOpenDeleteModal(
                    record.backofficeUserId,
                    `${record.firstname} ${record.lastname}`,
                  )
                }
              />
            )
          },
        }
      : {},
  ]

  const onTableChange = (pagination: TablePaginationConfig) => {
    const { current, pageSize } = pagination

    setPage(current || 1)
    setLimit(pageSize || 10)
  }

  const handelOpenDeleteModal = (backofficeUserId: string, fullname: string) => {
    return setDeleteAutoAssignModal({ open: true, backofficeUserId, fullname })
  }

  useEffect(() => {
    const subscription = inputChange$
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe((value) => {
        setSearch(value)
        setPage(1) // Reset to first page when search input changes
      })

    return () => {
      // Reset the BehaviorSubject value when the component unmounts
      inputChange.next('')
      return subscription.unsubscribe()
    }
  }, [])

  return { columns, queryListAutoAssignee, onTableChange, onSearch, handleAddUser }
}

export default AutoAssignTableHook
